export default __webpack_public_path__ + "static/media/réglement_icon.9441f8ec.svg";